import {OlivioLuminaire} from './olivioLuminaire';

class OlivioBollardLuminaire extends OlivioLuminaire {
	static designName = 'bollard';

	static models = {
		pole: {},
	};

	static modelPatterns = [
		{type: 'pole', pattern: /^Bollard_(?<id>(Medio)|(Piccolo))$/i, storageKeys: ['id']},
	];

	static hasBrackets = false;

	static singleBracket = true;

	static supportLayouts = false;

	static checkCollisions = false;

	static defaultConfig = {
		poleHeight: 1.2,
		numberOfHeads: 1,
		layout: 'none',
	};

	static getPoleId(configValues) {
		return +configValues.poleHeight === 1 ? 'piccolo' : 'medio';
	}

}

export {OlivioBollardLuminaire};

